import imp from '@/lib/imp';
import { UvRoute } from '@/lib/router';
import { Inventory, InventoryImportSource, ScripticItemType } from '@/pages/inventory/Inventory';

const baseRoute = `inventory.active.import.${InventoryImportSource.INITIAL}.${ScripticItemType.MF}`;

const route: UvRoute = {
  path: ScripticItemType.MF,
  name: baseRoute,
  props: true,
  meta: {
    header: {
      label: 'Lista cu mijloace fixe importate',
      parentRoute: 'inventory.active',
      menu: (route, { inventory }: { inventory: Inventory }) => [
        {
          label: 'Importa',
          icon: 'arrow_upward',
          disabled: inventory ? !inventory.config.types.mf.import.enabled : false,
          separated: true,
          route: {
            name: `${baseRoute}.upload`,
            params: route.params,
          },
        },
      ],
    },
    breadcrumb: {
      label: 'Lista cu mijloace fixe importate',
      route: baseRoute,
    },
  },
  component: imp(
    () =>
      import(
        '@/pages/inventory/active/import/initial/lists/mf/Main.vue' /* webpackChunkName: 'inventory.active.import.initial' */
      ),
  ),
  children: [
    {
      path: 'upload',
      name: `${baseRoute}.upload`,
      props: {
        source: InventoryImportSource.INITIAL,
        type: ScripticItemType.MF,
        parentRoute: { name: baseRoute },
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parentRoute: { name: `${baseRoute}.upload` },
      component: imp(
        () =>
          import(
            '@/pages/inventory/active/import/common/Upload.vue' /* webpackChunkName: 'inventory.active.import.initial' */
          ),
      ),
    },
  ],
};

export default route;
